
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { CourseButtonStyle } from '@xt/client/types/home.d'

@Component({
  components: {}
})
export default class extends Vue {
  @Prop() config: {
    type: 'normal' | 'countdown'
    endTime: number
    label: string
    suffix: string
    className: CourseButtonStyle
  }

  timer: ReturnType<typeof setInterval> | null = null
  formatedCountdownPrefix: string

  clearTick() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  startTick() {
    if (this.config.type !== 'countdown') return

    this.formatedCountdownPrefix = this.$store.$homeV2.formatEndTimeCountdownString(this.config.endTime)

    this.timer = setInterval(() => {
      this.formatedCountdownPrefix = this.$store.$homeV2.formatEndTimeCountdownString(this.config.endTime)
    }, 1000)
  }

  created(): void {
    if (this.config.type === 'countdown') {
      this.startTick()
    }
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.clearTick()
  }
}
